import(/* webpackMode: "eager" */ "/code/components/ui/Image/OptimizedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/components/ui/pagination/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/components/ui/Sidebar/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/code/node_modules/.pnpm/next@15.5.9_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_react-dom@19._yf3e5grukrg4xcdbnzck25bsyy/node_modules/next/dist/client/app-dir/link.js");
